(function() {
    'use strict';

    angular
        .module('bhsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('data-element', {
            parent: 'entity',
            url: '/data-element?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bhsApp.dataElement.home.title'
            },
            views: {
                'content@bhs': {
                    templateUrl: 'app/entities/data-element/data-elements.html',
                    controller: 'DataElementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dataElement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('data-element-detail', {
            parent: 'entity',
            url: '/data-element/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bhsApp.dataElement.detail.title'
            },
            views: {
                'content@bhs': {
                    templateUrl: 'app/entities/data-element/data-element-detail.html',
                    controller: 'DataElementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dataElement');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DataElement', function($stateParams, DataElement) {
                    return DataElement.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'data-element',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('data-element-detail.edit', {
            parent: 'data-element-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/data-element/data-element-dialog.html',
                    controller: 'DataElementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DataElement', function(DataElement) {
                            return DataElement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('data-element.new', {
            parent: 'data-element',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/data-element/data-element-dialog.html',
                    controller: 'DataElementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tableau: null,
                                colonne: null,
                                valeur: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('data-element', null, { reload: 'data-element' });
                }, function() {
                    $state.go('data-element');
                });
            }]
        })
        .state('data-element.edit', {
            parent: 'data-element',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/data-element/data-element-dialog.html',
                    controller: 'DataElementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DataElement', function(DataElement) {
                            return DataElement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('data-element', null, { reload: 'data-element' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('data-element.delete', {
            parent: 'data-element',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/data-element/data-element-delete-dialog.html',
                    controller: 'DataElementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DataElement', function(DataElement) {
                            return DataElement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('data-element', null, { reload: 'data-element' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
